<template>
  <div class="card">
    <h2 class="project-name">
      {{ orderInfo.orderName }}
    </h2>

    <!---谈判概况------>
    <div class="section">
      <div class="section-title">
        <base-section-title title="谈判概况" />
        <slot name="title"></slot>
      </div>
      <div class="section-content">
        <jczh-descriptions
          :el-attrs="{ column: 1 }"
          :info="orderInfo"
          :option="options"
        />
      </div>
    </div>

    <!---公告内容----->
    <div class="section">
      <div class="section-title">
        <base-section-title title="公告内容" />
        <slot name="title"></slot>
      </div>
      <div class="section-content">
        <h4>{{ (orderInfo.purchaseNotice || {}).title }}</h4>
        <u-editor disabled :value="(orderInfo.purchaseNotice || {}).content" />
      </div>
    </div>
  </div>
</template>
<script>
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import UEditor from '@/components/common/UEditor/index.vue'

import {
  previewClarificationFileApi,
  downloadClarificationFileApi
} from '@/api/procure/negotiation-v2'

import DateUtils from '@/utils/date'

export default {
  components: {
    BaseSectionTitle,
    UEditor
  },

  props: {
    orderId: {
      type: Number,
      default: 0
    },

    tradeId: {
      type: [Number, String],
      default: 0
    },

    title: {
      type: String,
      default: '谈判公告'
    },

    orderInfo: {
      type: Object,
      default: () => {}
    },

    attachmentList: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      previewClarificationFileApi,
      downloadClarificationFileApi,

      options: [
        { label: '采购单位', prop: 'ownerCompanyName' },
        {
          label: '代理单位',
          prop: 'purchaseCompanyName',
          hideFun: () =>
            this.orderInfo.purchaseCompanyName === this.orderInfo.ownerCompanyName
        },
        {
          label: '响应时间',
          prop: '',
          filter: value => DateUtils.getNormMinuteRange(value.offerStartTime, value.offerEndTime)
        },
        { label: '提交响应文件截止时间', prop: 'negotiateTime', isNormMinute: true },
        {
          label: '谈判地点',
          prop: '',
          filter: value => `${value.province} - ${value.city} - ${value.area}`
        },
        { label: '详细地址', prop: 'address' }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.file-section {
  width: 500px;
}

.project-name {
  text-align: center;
  font-size: pixel-to-rem($n: 26);
  @include text-bold;
  line-height: 1.5;
  padding: pixel-to-rem(20);
  padding-top: 0;
  border-bottom: 1px solid $border-color;
  margin-bottom: pixel-to-rem($n: 20);
}

// 公告内容样式
.notice-content {
  h4 {
    font-size: pixel-to-rem($n: 20);
  }
}
</style>
